<template>
	<Head title="Instruções da Prova"></Head>

	<div class="container">
		<div class="row align-items-center mt-10 mb-10 row-logo">
			<div class="col mx-auto text-center">
				<img
					alt="Logo Habilite-se"
					src="/habil/images/logo.svg"
					class="h-35px" />
			</div>
		</div>

		<div class="row align-items-center row-card">
			<div class="col-sm-10 col-md-10 col-lg-10 mx-auto text-center">
				<div class="card">
					<div class="card-body">
						<div class="text-center mb-10">
							<h2 class="m-0">Instruções da Prova</h2>
							<p style="font-size: 15px; color: #747a7e">
								Abaixo as instruções para realização da prova.
							</p>
						</div>
						<div class="row mb-10">
							<div class="col-lg-3 mt-4">
								<img
									src="/images/prova.png"
									class="h-150px rounded-circle" />
							</div>

							<div
								class="col-lg-9 mt-4 fw-bolder fs-3 text-gray-600"
								style="text-align: left">
								<p class="mb-3">
									1 - Você terá
									<span class="text-gray-800"
										>40 minutos</span
									>
									para a finalizar a prova.
								</p>
								<p class="mb-3">
									2 - A prova tem
									<span class="text-gray-800"
										>30 questões</span
									>.
								</p>
								<p class="mb-3">
									3 - Cada questão tem
									<span class="text-gray-800">4 opções</span>
									com somente
									<span class="text-gray-800">1 correta</span
									>.
								</p>
								<p class="mb-3">
									4 - É necessário clicar no botão
									<span class="text-gray-800"
										>"Confirmar Resposta"</span
									>
									para enviar sua resposta
								</p>
								<p class="mb-3">
									5 - Você precisa de pelo menos
									<span class="text-gray-800">70%</span>
									de acertos para aprovação.
								</p>
								<p class="mb-3">
									6 - Será necessário fazer a coleta de
									<span class="text-gray-800">Biometria</span>
									e
									<span class="text-gray-800">Foto</span>
									antes de iniciar, na metade e no final da
									prova.
								</p>
							</div>
						</div>

						<div class="text-center mt-3">
							<form
								v-if="props.spa_enabled"
								class="d-inline"
								@submit.prevent="submit">
								<button
									id="continue"
									class="btn btn-primary"
									:disabled="form.processing"
									type="submit">
									Continuar para liberação de prova
								</button>
							</form>

							<form
								v-else
								class="d-inline"
								method="post"
								:action="props.submitUrl">
								<input
									type="hidden"
									name="_token"
									:value="props.csrfToken" />
								<button
									id="continue"
									class="btn btn-primary"
									type="submit">
									Continuar para liberação de prova
								</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { Head, useForm } from '@inertiajs/vue3';
	import { onMounted, ref } from 'vue';
	import { commonStore } from '../../stores/common';
	import { checkConnection } from '../../websockets/WebsocketVerification';

	const common = commonStore();
	const props = defineProps({
		csrfToken: { type: String, required: true },
		submitUrl: { type: String, required: true },
		is_ws_verification: { type: Boolean, required: true },
		is_agent_support_ws_verification: { type: Boolean, required: true },
		computer_uid: { type: String, required: true },
		descricao_computer: { type: String, required: true },
		spa_enabled: { type: Boolean, required: false, default: false },
	});

	const form = useForm({
		_token: props.csrfToken,
	});

	function submit() {
		form.post(props.submitUrl);
	}

	const connectionSpinner = ref(true);
	const connectionStatus = ref({
		connection: false,
		verified: false,
	});

	onMounted(() => {
		common.startKeyUp();

		checkConnection(props, connectionStatus, connectionSpinner);

		setInterval(() => {
			checkConnection(props, connectionStatus, connectionSpinner);
		}, 25000);
	});
</script>
